/**
 * MessagingWindowBlock — substitui a sendbar quando a janela de 24h da Meta
 * (WhatsApp Business / Instagram / Messenger) fechou.
 *
 * Anatomia copiada do aviso de `waiting` que já existia no bloco de avisos do
 * ChatBox (faixa âmbar `#fffbeb`/`#b45309`, dot pulsante `#f59e0b`, `py-3.5`).
 * As cores são hardcoded aqui — mesma mistura do bloco original (container em
 * CSS vars, faixa em hex). Validação visual nos dois temas (Task 13 Step 5)
 * ainda está PENDENTE — não foi possível subir a aplicação nesta tarefa para
 * conferir. Confirmar manualmente (light + dark) ou via teste de browser
 * usando os `data-testid` abaixo antes de assumir que este bloco já foi visto
 * renderizado de verdade.
 *
 * `reopenWith` vem de `useMessagingWindow` (Task 12) e decide o texto/CTA:
 * - `'template'` — canal suporta template outbound; oferece reabrir via CTA
 *   que abre a `SendTemplateModal` já existente no `ChatBox`.
 * - `'customer_only'` — canal não suporta template fora da janela (ex.:
 *   Instagram/Messenger); só o cliente pode reabrir enviando mensagem nova.
 */

interface MessagingWindowBlockProps {
  reopenWith: 'template' | 'customer_only';
  onSendTemplate: () => void;
}

export function MessagingWindowBlock({ reopenWith, onSendTemplate }: MessagingWindowBlockProps) {
  return (
    <div
      className="flex items-center justify-center gap-2 px-4 py-3.5 text-sm font-medium"
      style={{ backgroundColor: '#fffbeb', color: '#b45309' }}
      data-testid="chat-messaging-window-closed"
    >
      <span
        className="w-2 h-2 rounded-full animate-pulse flex-shrink-0"
        style={{ backgroundColor: '#f59e0b' }}
      />
      {reopenWith === 'template' ? (
        <span>
          A janela de 24 horas (da Meta) foi encerrada. Para retomar a conversa,{' '}
          <button
            type="button"
            onClick={onSendTemplate}
            className="underline font-semibold"
            style={{ color: '#b45309' }}
            data-testid="chat-messaging-window-send-template"
          >
            envie um template
          </button>
          .
        </span>
      ) : (
        <span data-testid="chat-messaging-window-customer-only">
          A janela de 24 horas (da Meta) foi encerrada. Só é possível responder quando o
          cliente enviar uma nova mensagem.
        </span>
      )}
    </div>
  );
}
